import { graphql, useFragment } from 'react-relay';

import { TaskImageCreationDifferenceItemList_difference$key } from '../../../relay/__generated__/TaskImageCreationDifferenceItemList_difference.graphql';
import { isNullable } from '../../../utils/is';
import EmptyState from '../../core/EmptyState';
import ItemList from '../../core/ItemList';
import Katex from '../../core/Katex';
import Text from '../../core/Text';
import View from '../../core/View';
import DiffItem from '../../difference/DiffItem';

const TaskImageCreationDifferenceItemList_difference = graphql`
  fragment TaskImageCreationDifferenceItemList_difference on Difference {
    ... on TaskImageCreationDifference {
      problem {
        ...DiffItem_diff
      }
      solution {
        ...DiffItem_diff
      }
    }
  }
`;

type Props = { difference: TaskImageCreationDifferenceItemList_difference$key };

const TaskImageCreationDifferenceItemList = ({ difference }: Props) => {
  const { problem, solution } = useFragment(TaskImageCreationDifferenceItemList_difference, difference);

  const diffItems = [
    { title: '문제', diff: problem, renderItem: (beforeOrAfter: string) => <Katex>{beforeOrAfter}</Katex> },
    { title: '해설', diff: solution, renderItem: (beforeOrAfter: string) => <Katex>{beforeOrAfter}</Katex> },
  ].filter(({ diff }) => !isNullable(diff));

  return (
    <ItemList
      items={diffItems}
      renderItem={({ title, diff, renderItem }) => (
        <>
          <Text sx={{ fontSize: 1, fontWeight: 'bold' }}>{title}</Text>
          <View sx={{ marginTop: 2 }}>
            <DiffItem diff={diff!} renderItem={renderItem} />
          </View>
        </>
      )}
      renderItemWrapper={(children, { title }, i) => (
        <View key={title} sx={{ marginTop: i > 0 ? 3 : 0 }}>
          {children}
        </View>
      )}
      emptyState={
        <View sx={{ paddingY: 6 }}>
          <EmptyState
            title={'기록되지 않은 히스토리이에요'}
            description={'이 기능이 만들어지기 전에 일어난 일이거나 오류로 누락된 히스토리입니다.'}
          />
        </View>
      }
    />
  );
};

export default TaskImageCreationDifferenceItemList;
